import React from 'react';
import { Link } from 'react-router-dom';

interface IProps {
    url?: string;

    onClick?: () => void;
}

const ButtonView = ({ url, onClick }: IProps) => {
    const icon = <i className="fas fa-eye font-size-18"></i>;

    return (
        <>
            {
                url &&
                <Link className="text-primary mt-1" to={url}>
                    {icon}
                </Link>
            }
            {
                onClick &&
                <button className={`btn btn-link border-0 text-primary mt-1`}
                    onClick={ev => onClick()}>
                    {icon}
                </button>
            }
        </>
    );
};

export default ButtonView;